import React, { useCallback, useEffect } from "react";
import { Calendar, Clock } from "lucide-react";

import FiltroPeriodo from "../components/FiltroPeriodo";
import { Esmaecer, EsqueletoVisaoGeral } from "../components/Esqueletos";
import { buscarPeriodo, buscarResumo } from "../lib/api";
import { useDados, usePeriodo } from "../lib/usePeriodo";
import BarrasComTicket from "./BarrasComTicket";
import CardsKpi from "./CardsKpi";
import DonutsResumo from "./DonutsResumo";
import FaturamentoDiario from "./FaturamentoDiario";
import InsightsCombos from "./InsightsCombos";
import TopClientes from "./TopClientes";

const tituloDia = (d) => {
  const n = d.dias_com_venda || 0;
  // A média por ocorrência evita que um mês com 5 sextas pareça melhor só por
  // ter uma sexta a mais.
  return n
    ? `${d.dia_completo} — ${n} ${n === 1 ? "dia" : "dias"} com venda · média ${(d.faturamento / n).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`
    : `${d.dia_completo} — sem vendas no período`;
};

// Relatórios → Relatório de Vendas (o panorama do período).
export default function VisaoGeralTab({ definirAtualizar, onAbrirSecao, periodoInicial }) {
  const p = usePeriodo(periodoInicial);
  const periodo = useDados(buscarPeriodo, p.periodo, { rotulo: "o relatório" });
  const resumo = useDados(buscarResumo, p.periodo, { rotulo: "o resumo" });
  const carregando = periodo.carregando || resumo.carregando;
  const recarregarPeriodo = periodo.recarregar;
  const recarregarResumo = resumo.recarregar;
  const recarregar = useCallback(() => { recarregarPeriodo(); recarregarResumo(); }, [recarregarPeriodo, recarregarResumo]);

  useEffect(() => { definirAtualizar({ recarregar, carregando }); }, [definirAtualizar, recarregar, carregando]);

  const r = resumo.dados;
  return (
    <div className="space-y-6">
      <FiltroPeriodo {...p} />
      {/* Esqueleto só até as DUAS primeiras respostas (cartões e gráficos); depois
          trocar o período só esmaece o que já está na tela. */}
      {!(periodo.carregou && resumo.carregou) ? <EsqueletoVisaoGeral /> : (
        <Esmaecer ativo={carregando}>
          {periodo.dados && <CardsKpi dados={periodo.dados} />}
          <FaturamentoDiario pontos={periodo.dados?.grafico} />
          <BarrasComTicket titulo="Vendas por Dia" icone={Calendar} dados={r?.vendas_por_dia_semana} chaveX="dia"
            balaoTitulo={tituloDia} e2e="vendas-por-dia" />
          <BarrasComTicket titulo="Vendas por Hora do Dia" icone={Clock} dados={r?.vendas_por_hora} chaveX="hora"
            balaoTitulo={(d) => `Das ${d.hora.replace("h", "")}h às ${d.hora.replace("h", "")}h59`} e2e="vendas-por-hora" />
          <DonutsResumo formasPagamento={r?.formas_pagamento} modulos={r?.modulos} onVerDetalhes={onAbrirSecao} />
          <TopClientes clientes={r?.top_clientes}
            onVerTodos={() => onAbrirSecao("clientes", { filtro: p.filtro, dataInicio: p.dataInicio, dataFim: p.dataFim })} />
          <InsightsCombos analise={r?.analise_produtos} />
        </Esmaecer>
      )}
    </div>
  );
}
